<template>
  <div>
    <Nav :showMobileSearch="false" ref="Nav"/>
    <div class="musician-detail">
      <div class="main-box">
        <div class="user-info">
          <div class="avatar" >
            <img v-if="personDetail.img" :src="personDetail.img" alt="" />
            <div
              v-else
              :class="
                'base-pic-placeholder-detail bg' + parseInt(Math.random() * 6)
              "
            >
              {{personDetail.name ? personDetail.name["@value"].substring(0, 1) : '' }}
            </div>
          </div>
          <div class="info">
            <div class="name" v-if="personDetail.name">
              {{ personDetail.name["@value"] }}
            </div>
            <div
              :class="showMore ? 'desc cur' : 'desc'"
              v-if="personDetail.briefBiography"
            >
              <p>{{ personDetail.briefBiography.replace(/,/g,'，').replace(/[.]/g,'。').split('（来源')[0]}}</p>   
            </div>
         <template v-if="!isMobile">
          <a style="float:right;color:#EB5757;padding-right:10px;" v-if="!isMobile && personDetail['@id'] && personDetail['@id'].indexOf('http://data.library.sh.cn/entity/person')>=0" @click="toNames(personDetail['@id'])">查看更多></a>
             </template>
            <a
              href="javascript:"
              :class="showMore ? 'more cur' : 'more'"
              @click="showMore = !showMore"
              >{{ showMore ? "收起" : "展开" }}<i></i
            ></a>
            <div class="btns">
              <ShareDialog ref="share"
                ><a href="javascript:" class="share" @click="handleShare"
                  ><i></i>分享</a
                ></ShareDialog
              >
              <a
                href="javascript:"
                :class="isFav ? 'fav cur' : 'fav'"
                @click="handleSingleFav"
                ><i></i>收藏</a
              >
            </div>
          </div>
        </div>
        
        <div class="mb-des" v-if="personDetail.briefBiography">
          <div :class="showMore ? 'desc cur' : 'desc'">
            <p>{{ personDetail.briefBiography.replace(/,/g,'，').replace(/[.]/g,'。').split('（来源')[0]}}</p>  
          </div>
       
          <a style="float:right;color:#EB5757;font-size:0.10rem" v-if="personDetail['@id'] && personDetail['@id'].indexOf('http://data.library.sh.cn/entity/person')>=0" @click="toNames(personDetail['@id'])">查看更多></a>
          
          <a
            href="javascript:"
            :class="showMore ? 'more cur' : 'more'"
            @click="showMore = !showMore"
            >{{ showMore ? "收起" : "展开" }}<i></i
          ></a>
        </div>
        <div class="result-count">
          <span
            >唱片<b>{{ recordCount }}</b>种</span
          >
             <div class="sort">
                <span :class="sorts[0] ? 'cur' : ''" @click="onSorts(0)"
                  >题名</span
                >
                <span :class="sorts[1] ? 'cur' : ''" @click="onSorts(1)"
                  >出版时间</span
                >
                <span :class="sorts[2] ? 'cur' : ''" @click="onSorts(2)"
                  >责任者</span
                >
                <span
                  :class="onlyShowPlay ? 'only-can-play cur' : 'only-can-play'"
                  @click="onlyCanPlay"
                  >可播放唱片</span
                >
              </div>
        </div>
        <div class="record-list" v-if="recordList && recordList.length > 0">
          <div
            v-for="(item, index) in recordList"
            :key="'recordList' + index"
            class="record-cell"
          >
               <div class="pic" >
                    <router-link :to="'/rec-info/'+encodeURIComponent(item['@id'])" v-if="item.title"> 
                  <img
                    v-if="item.cover[0]"
                    :src="
                      'https://img.library.sh.cn/hisdata/cp/img/' +
                      item.cover[0]
                    "
                    alt=""
                  />
                  <img v-else :src="baseRecordPic" alt="" />
                  </router-link>
                    <div v-if="item.playable" class="h-box" @click="playSong(item, index)">
                    </div>
                </div>
            <router-link
              :to="'/rec-info/' + encodeURIComponent(item['@id'])"
              class="tit"
              v-if="item.dcTitle"
            >
              {{ item.dcTitle["@value"]}}
            </router-link>
            <div class="info" v-if="item.creator">{{ item.creator }}</div>
            <div v-if="!isMobile && item.date" class="info">{{ item.date }}</div>
          </div>
          <div class="clear-f"></div>
        </div>
        <div class="page-box">
          <a-pagination
            :total="pagerCount"
            :current="currentPage"
            @change="onChange"
            show-quick-jumper
            show-less-items
          />
        </div>
      </div>
    </div>
    <Footer />
    <Player ref="player" @curPlay="curPlay"/>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import Footer from "@/components/footer";
import Player from "@/components/player";
import ShareDialog from "@/components/shareDialog";
import { baseRecordPic } from "@/util/basePic";
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
  navigator.userAgent
);
import {
  personInfo,
  phonorecordSearchGet,
  phonorecordInfo,
  collFav,
  ncollFav,
  musicInfo,
} from "@/api";
export default {
  components: {
    Nav,
    Footer,
    ShareDialog,
    Player,
  },
  data() {
    return {
      sc:false,
      playIndex:-1,
      curIndex:-1,
      isMobile,
      visible:false,
      noplay:false,
      audioDetail: [],
      playerList: [],
      player: [],
      loginHref:false,
      queryUri: decodeURIComponent(this.$route.params.id),
      baseRecordPic,
      searchType: 1, // 检索类型 1：简单检索，2：高级检索，3：专业检索
      hasAudio: false, //是否可播放标记 chenss
      onlyShowPlay: false,//是否可播放标记 chenss
      searchParams: {}, // 检索参数
      phonorecordParams: {
        // 唱片检索参数
        field: "COURI",
        value: "",
        sort: "TI",
        order: 1,
        PLAY: '',//是否可播放，默认全部查询 chenss
        pageth: 1,
        pageSize: 10,
      },
      yr: [],
      avatar: require("./../../../public/img/demo/image2.png"),
      showMore: false,
      isFav: false,
      visible: false,
      pagerCount: 1,
      currentPage: 1, // 当前页码
      personDetail: {},
      recordCount: 0,
      recordList: [],
      sorts: [true, false, false],
    };
  },
   watch: {//解决此画面打开时，再从浏览器通过其他参数打开该画面 能正常打开
    $route(to, from) {
      var id = this.$route.params.id;
      //console.log("route change", id);

      this.queryUri = decodeURIComponent(this.$route.params.id);
      this.query();
    },
  },
  mounted() {
    this.loginHref = this.GLOBAL.BASE_LOGIN_URL + window.location.href
    this.$nextTick(() => {
      this.query();//默认查询人物详情
      if(this.GLOBAL.BASE_IP_INFO.ipIsInner){//如果是内网，直接勾选可播放按钮 chenss 20220831
        // 仅显示可播放唱片
        this.onlyShowPlay = true;
        this.hasAudio = this.onlyShowPlay;
        this.phonorecordParams.PLAY = "1";
      }
      this.phonorecordSearchQuery();
    });
  },
  beforeRouteLeave(to, form, next) {
    this.$refs.player.savePlayer()
    next();
  },
  methods: {
    async query() {
      // 查询
      const res = await personInfo({ uri: this.queryUri });
      const result = res.data;
      this.isFav = result.datas.isFavorite;
      this.personDetail = result.datas;
    },
     onlyCanPlay() {
      // 仅显示可播放唱片
      this.onlyShowPlay = !this.onlyShowPlay;
      this.hasAudio = this.onlyShowPlay;
      //console.log(this.hasAudio)
       this.phonorecordParams.PLAY='';
      if (this.hasAudio){
        this.phonorecordParams.PLAY = "1";
       }
      this.phonorecordSearchQuery();
    },
    async phonorecordSearchQuery() {
      this.phonorecordParams.value = this.queryUri;
      this.phonorecordParams.pageth = this.currentPage;
      // 排序
      this.phonorecordParams.sort = "";
      if(this.sorts[0]) this.phonorecordParams.sort = 'TI';
      if(this.sorts[1]) this.phonorecordParams.sort = 'TIME';
      if(this.sorts[2]) this.phonorecordParams.sort = 'CO';
      const res = await phonorecordSearchGet(this.phonorecordParams);
      const result = res.data;
      this.recordList = result.datas;
      this.recordCount = result.pager.rowCount;
      // 页码
      this.pagerCount =
        result.pager && result.pager.rowCount ? result.pager.rowCount : 1;
    },
    schandleCancel(){
      this.sc = false
    },
    handleOk(){
      this.isLogin = true
      this.visible = false
    },
    handleCancel(){
      this.visible = false
    },
    nohandleCancel(){
      this.noplay = false
    }
    ,
    async handleSingleFav() {
      if (!localStorage.getItem("token")) {
        this.$refs.Nav.showTk(2);
        return;
      }
      //console.log(this.personDetail["@id"]);
      const res = this.isFav
        ? await ncollFav({ uri: this.personDetail["@id"] })
        : await collFav({ uri: this.personDetail["@id"] });

      //console.log(res);
      this.isFav = !this.isFav;
      this.$refs.Nav.cpnclick(this.isFav);
    },
    handleShare() {
      // this.$refs.share.visible = !this.$refs.share.visible;
      this.$refs.share.show();
    },
     toNames(uri) {
      // window.location.href="http://names.library.sh.cn/mrgf/service/work/persons?uri=http://data.library.sh.cn/entity/person/hwcbf01uiyq4p4cm&dataType=1";
     window.open("http://names.library.sh.cn/mrgf/service/work/persons?uri="+uri);
    },
    onSorts(n) {
     // 排序
      this.sorts.splice(n, 1, !this.sorts[n]);
      let allFalse = 1
      this.sorts.forEach((item, index) => {
        if (n != index) {
          this.sorts[index] = false;
        }
        if(item == true){
          allFalse = 2
        }
      });
      if(allFalse == 1){
        this.sorts[0] = true;
      }
      this.phonorecordSearchQuery();
    },
    onChange(current) {
      // 页码点击
      this.currentPage = current;
      this.phonorecordSearchQuery();
    },
    handleCancel() {
      this.visible = false;
    },
    curPlay(){
      this.playIndex = this.curIndex;
    },
    async playSong(item,index) {
      this.curIndex = index;
      this.$refs.player.playSong(this.$refs.Nav, item);
    },
  },
};
</script>
